
import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useFavorites } from '../hooks/useFavorites';
import AuthModal from './AuthModal';

interface FavoriteButtonProps {
  itemType: string;
  itemId: string;
  itemTitle: string;
  itemImage: string;
  itemData?: any;
  className?: string;
  showLabel?: boolean;
}

export default function FavoriteButton({
  itemType,
  itemId,
  itemTitle,
  itemImage,
  itemData,
  className = '',
  showLabel = false,
}: FavoriteButtonProps) {
  const { isAuthenticated } = useAuth();
  const { isFavorite, toggleFavorite } = useFavorites();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!isAuthenticated) {
      setShowAuthModal(true);
      return;
    }

    setLoading(true);
    await toggleFavorite(itemType, itemId, itemTitle, itemImage, itemData);
    setLoading(false);
  };

  const favorited = isFavorite(itemId);

  return (
    <>
      <button
        onClick={handleClick}
        disabled={loading}
        className={`flex items-center gap-2 transition-colors disabled:opacity-50 ${className}`}
        title={favorited ? 'Remove from favorites' : 'Add to favorites'}
      >
        <i
          className={`${
            favorited ? 'ri-heart-fill text-red-500' : 'ri-heart-line text-gray-600'
          } text-xl`}
        ></i>
        {showLabel && (
          <span className="text-sm font-medium whitespace-nowrap">
            {favorited ? 'Saved' : 'Save'}
          </span>
        )}
      </button>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onSuccess={() => setShowAuthModal(false)}
      />
    </>
  );
}
